module.exports = __webpack_public_path__ + "static/foto-riso-a73ec737c4ae32a2e87789b352555edd.png";